import { findIndex, isEmpty } from 'lodash';
import { Map } from 'immutable';
import { TM_DEFAULT_TEAM_DISPLAY_NAME } from '@saucelabs/sl-util-config';

import * as types from './types';

const getTeams = ({ headers, rows, maxConcurrency }) => {
  const teamColumnIndex = findIndex(headers, (header) => header.trim() === 'team');
  return rows.reduce((teams, user) => {
    const userTeam = user[teamColumnIndex] && user[teamColumnIndex].trim();
    const userTeamName = isEmpty(userTeam) ? TM_DEFAULT_TEAM_DISPLAY_NAME : userTeam;

    if (!teams[userTeamName]) {
      teams[userTeamName] = { // eslint-disable-line no-param-reassign
        usersCount: 0,
        overall: maxConcurrency,
      };
    }

    teams[userTeamName].usersCount += 1; // eslint-disable-line no-param-reassign

    return teams;
  }, {});
};

const initialState = new Map({
  errorMessage: false,
  form: {},
  loading: true,
  subaccounts: 0,
  teamsConfig: null,
  uuid: null,
});

const migrationWizardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_SUBACCOUNTS.ERROR:
      return state.set('loading', false);
    case types.GET_SUBACCOUNTS.SUCCESS:
      return state
        .set('subaccounts', payload.users_total);
    case types.INITIALIZED:
      return state
        .set('loading', false);
    case types.TRANSFER_ORGANIZATION.SUCCESS:
      return state.set('uuid', payload.uuid);
    case types.SHOW_ERROR:
      return state.set('errorMessage', payload);
    case types.SET_TEAMS: {
      const teams = getTeams(payload);
      return state.set('teamsConfig', {
        teams,
        teamsCount: Object.keys(teams).length,
        usersCount: payload.rows.length,
      });
    }
    default:
      return state;
  }
};


export default migrationWizardReducer;
export {
  initialState,
  getTeams,
};
